import Barcode from "react-barcode";
import moment from 'jalali-moment';
import { IoMdArrowDropleft } from "react-icons/io";
import { convertToIranLocalNumber } from "src/utils/convertToIranLocalNumber";

export default function ParcelUI({ parcelData, orderData }) {
    return (
        <>
            <div className="flex gap-2 border border-gray-600 p-2">
                <div className="flex gap-1 border border-gray-600 flex-[5] p-2">
                    <div className="flex flex-col text-sm flex-[2]">
                        <div className="flex w-full justify-center">
                            <div className="flex flex-col items-center gap-1 mb-2 text-sm">
                                <img src="/assets/img/logos/epost.png" />
                                <span className="text-xs">
                                    شرکت ملی پست
                                </span>
                                <span className="text-xs">
                                    خدمت تجارت الکترونیک /پیشتاز
                                </span>
                            </div>
                        </div>
                        <div className="w-full h-[1px] bg-black"></div>
                        <div className="flex items-center">
                            <span>
                                مبدا
                            </span>
                            <IoMdArrowDropleft />
                            <span>
                                تهران منطقه 14 پستی تهران
                            </span>
                        </div>
                        <div className="w-full h-[1px] bg-black"></div>
                        <div className="flex items-center">
                            <span>
                                مقصد
                            </span>
                            <IoMdArrowDropleft />
                            <span>
                                {orderData?.state}، {orderData?.city}
                            </span>
                        </div>
                        <div className="w-full h-[1px] bg-black"></div>
                        <div className="flex gap-6 w-full items-center">
                            <div className="flex items-center">
                                <span>
                                    وزن
                                </span>
                                <IoMdArrowDropleft />
                                <span>
                                    {parcelData?.SumWeight} گرم
                                </span>
                            </div>
                            <div className="flex items-center">
                                <span>
                                    تاریخ
                                </span>
                                <IoMdArrowDropleft />
                                <span>
                                    {
                                        moment
                                            .from(parcelData?.createdAt, "en")
                                            .locale("fa")
                                            .format("jYYYY/jMM/jDD HH:mm")
                                    }
                                </span>
                            </div>
                        </div>
                        <div className="w-full h-[1px] bg-black"></div>
                        <div className="flex gap-6 items-center ">
                            <div className="flex items-center">
                                <span>
                                    کرایه پستی
                                </span>
                                <IoMdArrowDropleft />
                                <span>
                                    {parcelData?.ShippingCost} ریال
                                </span>
                            </div>
                            <div className="flex items-center">
                                <span>
                                    مالیات کرایه پستی
                                </span>
                                <IoMdArrowDropleft />
                                <span>
                                    {parcelData?.ShippingCostTax} ریال
                                </span>
                            </div>
                        </div>
                        <div className="w-full h-[1px] bg-black"></div>

                        <Barcode height={45} fontSize={20} width={1.7} value={parcelData?.ParcelCode} />
                    </div>
                    <div className="flex relative">
                        <div className="rotate-90 w-[50px] absolute top-[200px] left-0">
                            <Barcode height={25} width={1.3} fontSize="16" value={parcelData?.ParcelCode} />
                        </div>
                    </div>
                </div>
                <div className="flex flex-[3] p-2 border border-gray-600">
                    <div className="flex flex-[2] flex-col gap-1 text-sm">
                        <div className="flex gap-1">
                            <span className="font-bold">فرستنده (فروشگاه):</span>
                            <span>بدورژ</span>
                        </div>
                        <div className="flex gap-5">
                            <div className="flex gap-1">
                                <span className="font-bold">استان:</span>
                                <span>تهران</span>
                            </div>
                            <div className="flex gap-1">
                                <span className="font-bold">شهر:</span>
                                <span>منطقه 14 پستی تهران</span>
                            </div>
                        </div>
                        <div className="flex gap-5">
                            <div className="flex gap-1">
                                <span className="font-bold">آدرس:</span>
                                <span>تهران، اشرفی اصفهانی شمال، بعد از پونک،
                                خیابان امام حسن، پالک ۲۷ واحد ۴</span>
                            </div>
                        </div>
                        <div className="flex gap-1">
                            <span className="font-bold">شناسه صاپست:</span>
                            <span>---</span>
                        </div>
                        <div className="flex gap-5">
                            <div className="flex gap-1">
                                <span className="font-bold">کدپستی:</span>
                                <span>1469916469</span>
                            </div>
                            <div className="flex gap-1">
                                <span className="font-bold">تلفن:</span>
                                <span>02191007279</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex justify-center items-center gap-2">
                <div className="flex flex-[5] flex-col gap-1 p-2 text-sm border border-gray-600">
                    <div className="flex gap-1">
                        <span className="font-bold">گیرنده (خریدار):</span>
                        <span>{orderData?.fullName}</span>
                    </div>
                    <div className="flex gap-5">
                        <div className="flex gap-1">
                            <span className="font-bold">استان:</span>
                            <span>{orderData?.state}</span>
                        </div>
                        <div className="flex gap-1">
                            <span className="font-bold">شهر:</span>
                            <span>{orderData?.city}</span>
                        </div>
                    </div>
                    <div className="flex gap-1">
                        <span className="font-bold">آدرس:</span>
                        <span>{orderData?.address}</span>
                    </div>
                    <div className="flex gap-5">
                        <div className="flex gap-1">
                            <span className="font-bold">کدپستی:</span>
                            <span>{orderData?.postcode}</span>
                        </div>
                        <div className="flex gap-1">
                            <span className="font-bold">تلفن ثابت:</span>
                            <span>{convertToIranLocalNumber(orderData?.phoneNumber)}</span>
                        </div>
                    </div>
                    <div className="flex gap-5">
                        <div className="flex gap-1">
                            <span className="font-bold">تلفن همراه:</span>
                            <span>{convertToIranLocalNumber(orderData?.phoneNumber)}</span>
                        </div>
                        <div className="flex gap-1">
                            <span className="font-bold">پیام:</span>
                            <span>---</span>
                        </div>
                    </div>
                </div>
                <div className="flex gap-2 flex-[3] mr-6">
                    <span>مقصد:</span>
                    <span className="font-bold">{orderData?.state} - {orderData?.city}</span>
                </div>
            </div>
        </>
    )
}
